import router from '@/router';
import {RegisterNavigation,ResumeFsm} from '@/store/modules/fsm/messages';

export default ({tree,parent,api}) => {
  if(!tree)
  {
    let {addState,PseudoStateKind} = api;
    let here = parent.active;
    addState('init',here,PseudoStateKind.ShallowHistory);
  }
  else
  {
    let { messageIs } = api;
    let here = parent.active;

    here.init
      .to(here.adminregister);
    here.adminregister
      .to()
      .when(messageIs(ResumeFsm));
      // .effect(()=>router.push({name:RegisterNavigation}));
      // .effect(()=>{alert('?')});

  }
};
